const STATUS = ["To do", "In progress", "Done"];
const COLOR = { "To do": "#94A3B8", "In progress": "#FCD34D", Done: "#34D399" };

export default function AssetsView({ assets, onUpdate }) {
  const done = assets.filter((a) => a.status === "Done").length;
  return (
    <section className="card p-5" data-testid="assets-view">
      <div className="flex items-baseline justify-between mb-4">
        <div>
          <div className="eyebrow">Prepare before sending anything</div>
          <h2 className="text-xl font-extrabold mt-1">Core assets</h2>
        </div>
        <span className="mono text-xs" style={{ color: "var(--text-2)" }} data-testid="assets-progress">{done}/{assets.length} ready</span>
      </div>
      <ul className="grid md:grid-cols-2 gap-3">
        {assets.map((a) => (
          <li key={a.id} className="p-4 rounded-xl flex flex-col gap-2" style={{ background: "var(--surface-2)", borderLeft: `3px solid ${COLOR[a.status]}` }} data-testid={`asset-${a.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="mono text-[10px] uppercase tracking-wider" style={{ color: "var(--muted)" }}>{a.category}</div>
                <div className="text-sm font-semibold mt-1">{a.title}</div>
              </div>
              <select className="select select-inline" value={a.status} onChange={(e) => onUpdate(a, e.target.value)} style={{ color: COLOR[a.status] }} data-testid={`asset-status-${a.id}`}>
                {STATUS.map((s) => <option key={s} style={{ color: "#f8fafc", background: "#171a26" }}>{s}</option>)}
              </select>
            </div>
            <p className="text-xs leading-relaxed" style={{ color: "var(--text-2)" }}>{a.note}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
